let prefix = '/api/failuresScheduled';

function getFailureScheduled() {
    return window.axios.get(prefix);
}

function store(data) {
    return window.axios.post(prefix, data);
}

export default {
    getFailureScheduled,store
    
}